import React, {
  createContext,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import {FormikProvider} from 'formik';
import {useTaskAndNotesGridContext} from '../../_common/contexts/TaskAndNotesGridContext';

const InspectionDetailsTasksContext = createContext('');

export function useInspectionDetailsTasksContext() {
  return useContext(InspectionDetailsTasksContext);
}

export function InspectionDetailsTasksProvider({children}) {
  const {formik} = useTaskAndNotesGridContext();

  return (
    <InspectionDetailsTasksContext.Provider>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </InspectionDetailsTasksContext.Provider>
  );
}

InspectionDetailsTasksProvider.propTypes = {
  children: PropTypes.node,
};
